<template>
  <div class="main-wrapper" :class="!minibar ? '' : 'mini-sidebar'">
  	 <Header />

    <SidebarUser/>
    <div class="page-wrapper">
      <div class="container-fluid">
    	   <router-view />
      </div>   
	</div>   
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";  
import Header from "../components/Dashboard/Topbar_Diklat";

import SidebarUser from "../components/Dashboard/SidebarUser"; 
export default {
  computed: {
    ...mapState({
       minibar: state => state.minibar
    })
  },
	components: {
   		Header,
    	 SidebarUser
  	},
	 name: "diklat",
   data() {
        return  {
           is_sidebar : true 
        }
    } ,
   mounted: function () 
    {

        this.initial();
    },
    methods: {
        initial() {
          let profile =  JSON.parse(localStorage.getItem( 'profile'))
          if(profile.template == 'public') {
              this.is_sidebar = false 
          } else {
              this.is_sidebar = true 
          }
          console.log( profile)

        }

    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/layout/diklat.vue